module.exports = __webpack_public_path__ + "img/T-troja.c4cc4652.png";